//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters } from 'vuex'

export default {
  props: {
    showAccount: {type: Boolean, default: false}
  },
  computed: {
    ...mapState('session', ['directoryUrl', 'user']),
    ...mapGetters('session', ['activeAccount']),
    userAvatarUrl() {
      return `${this.directoryUrl}/api/avatars/user/${this.user.id}/avatar.png`
    },
    accountAvatarUrl() {
      let url = `${this.directoryUrl}/api/avatars/${this.activeAccount.type}/${this.activeAccount.id}`
      if (this.activeAccount.department) url += `/${this.activeAccount.department}`
      url += '/avatar.png'
      return url
    }
  },
}
